import { Grid, styled } from "@mui/material";

export const LightGrayBackground = styled(Grid)(({ theme }) => ({
    backgroundColor: "#F4F4F5",
    paddingBlock: theme.spacing(1.5),
    paddingInline: theme.spacing(2),
    borderRadius: theme.shape.borderRadius / 2,
}));
